const {
  assocPath,
  curry,
  find,
  isNil,
  path,
  tap,
} = require('ramda')
const { Future } = require('ramda-fantasy')

let cache = {}

function dispatcherGet (type, streams, req, predicate, id) {
  const cachedEntity = find(predicate(id), streams.main.extract())
  const cachedFuture = path([ type, id ], cache)
  if (!isNil(cachedEntity)) {
    return Future.of(cachedEntity)
  } if (!isNil(cachedFuture)) {
    return cachedFuture
  }
  const future = Future.cache(req(id).map(tap(streams.add.put)))
  cache = assocPath([ type, id ], future, cache)
  return future
}

module.exports = curry(dispatcherGet)
